(function(){
  'use strict';
  function init(){
    var dialog=document.querySelector('[data-welcome]');if(!dialog)return;
    var key='unify-ecom-welcome-shown',shown=false,opener,animation;
    try{shown=Date.now()-Number(localStorage.getItem(key)||0)<86400000;var legacy=JSON.parse(localStorage.getItem('unify_popup_v2')||'{}');if(Date.now()-Number(legacy.captured||0)<90*86400000||Date.now()-Number(legacy.dismissed||0)<7*86400000)shown=true;}catch(error){}
    function animate(closing){
      if(animation)animation.cancel();
      if(matchMedia('(prefers-reduced-motion:reduce)').matches){if(closing)dialog.close();return;}
      animation=dialog.animate([{opacity:closing?1:0,transform:closing?'translateY(0)':'translateY(20px)'},{opacity:closing?0:1,transform:closing?'translateY(20px)':'translateY(0)'}],{duration:300,easing:'cubic-bezier(.4,0,.2,1)',fill:'both'});
      animation.onfinish=function(){if(closing)dialog.close();animation.cancel();animation=null;};
    }
    function check(){
      if(shown||document.hidden||window.Shopify&&Shopify.designMode||document.querySelector('dialog[open]')||document.body.style.overflow==='hidden')return;
      var range=document.documentElement.scrollHeight-innerHeight;
      if(range<=0||scrollY/range<.25)return;
      shown=true;opener=document.activeElement;
      try{localStorage.setItem(key,String(Date.now()));}catch(error){}
      dialog.showModal();animate(false);window.removeEventListener('scroll',check);
    }
    dialog.querySelector('[data-welcome-close]').addEventListener('click',function(){animate(true);});
    dialog.addEventListener('cancel',function(event){event.preventDefault();animate(true);});
    dialog.addEventListener('click',function(event){if(event.target!==dialog)return;var r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)animate(true);});
    dialog.addEventListener('close',function(){if(opener&&opener.focus)opener.focus({preventScroll:true});});
    dialog.addEventListener('unify:signup-success',function(){dialog.querySelector('form').hidden=true;dialog.querySelector('[data-welcome-success]').hidden=false;try{localStorage.setItem('unify_popup_v2',JSON.stringify({captured:Date.now()}));}catch(error){}});
    window.addEventListener('scroll',check,{passive:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
